import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';

import DateTimePicker from 'react-datetime-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import {addCharity} from '../../../redux/actions/charityActions';
import NumberFormat from "react-number-format";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { createHashHistory } from "history";
const history = createHashHistory();

let isLoading = "false";
class AddCharity extends Component {
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'Add Charity'], 
      links: ["home",'/charity-setting'],
      country: "",
      countryName: "",
      state:"",
      stateAbbr: "",
      city: "",
      cityID: "",
      charity_name: "",
      address1: "",
      address2: "",
      zipcode: "",
      phone: "",
      email: "",
      status: "active",
      countryerror:'false',
      stateerror:'false',
      cityerror:'false',
      show: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);

    // Alert
	this.handleDismiss = this.handleDismiss.bind(this);
	this.handleShow = this.handleShow.bind(this);

	this.Clear=this.Clear.bind(this);
  }

	handleDismiss() {
		this.setState({ messageShow: false });
	}

	handleShow() {
		this.setState({ messageShow: true });
	}

  handleChange = (e) => {
  	if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
  	this.setState({[e.target.name]: e.target.value});
  }

  Clear(){
  	(this.state.state = ""),
  	(this.state.stateAbbr = ""),
  	(this.state.city = ""),
  	(this.state.cityID = ""),
  	(this.state.charity_name = ""),
  	(this.state.address1 = ""),
  	(this.state.address2 = ""),
  	(this.state.zipcode = ""),
  	(this.state.phone = ""),
  	(this.state.email = ""),
  	(this.state.status = "active");
  }

  componentWillMount(){
    this.props.clearAlert();
    this.handleDismiss();
  }

  componentWillReceiveProps(nextProps){
  	if(this.props.charityResponse !== nextProps.charityResponse){
  		if(nextProps.charityResponse){
  		  this.props.clearAlert();
          this.handleShow();
          if(nextProps.charityResponse.response == 'success'){
          	this.Clear();
          	this.onSelectedCountry();
            this.props.renderAlert("success", nextProps.charityResponse.message);
          }else{
            this.props.renderAlert("danger", nextProps.charityResponse.message);
          }
          window.scrollTo(0, 0);
          isLoading = "false";
  		}
  	}
  	if (this.props.error !== nextProps.error) {
	    if (nextProps.error) {
	      this.props.clearAlert();
	      this.handleShow();
	      this.props.renderAlert("danger", nextProps.error);
	      window.scrollTo(0, 0);
	      isLoading = "false";
	    }
	}
	if (nextProps.message) {
		this.handleShow();
		this.setState({
		  alertMessage: nextProps.message,
		  msgType: nextProps.alertType
		});
	}
  }

  validate = (e) => {
    let isError = false;

    if(!this.state.charity_name){
      isError = true;
      this.setState({charity_nameError:"red"})
    }

    if(!this.state.email){
      isError = true;
      this.setState({emailError:"red"})
    }

    if(!this.state.address1){
      isError = true;
      this.setState({address1Error:"red"})
    }

    if(!this.state.country){
      isError = true;
      this.setState({countryerror:"true"})
    }
   
    if(!this.state.state){
      isError = true;
      this.setState({stateerror:"true"})
    }

    if(!this.state.city){
      isError = true;
      this.setState({cityerror:"true"})
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
    	isLoading = "true";
		const constData = {
		    country: this.state.country,
	      state:this.state.stateAbbr,
        city: this.state.city,
	      city_id: this.state.cityID,
	      charity_name: this.state.charity_name,
	      address1: this.state.address1,
	      address2: this.state.address2,
	      zipcode: this.state.zipcode,
	      phone: this.state.phone,
	      email: this.state.email,
	      status: "active",
		}
		this.props.addCharity(constData);
    }
  }
  onSelectedCountry  = (val, key) => {
	  this.setState({country:val});
	  this.setState({countryName:key});
    if (!this.state.country) {
      this.setState({ countryError: "" });
    }

	  if(this.state.country != val || typeof val !== 'undefined'){
	    this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
	  }
  };

  onSelectedState = (val,key) => {
    this.setState({state:key})
    this.setState({stateAbbr:val})
  };

  onSelectedCity = (val,key) => {
   this.setState({city: val});
   this.setState({cityID: key});
   if(this.state.cityID.length === 0){
    this.setState({cityIDError:""})
   }
  }

  render() {
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Add Charity</header>
          <div className="panel-body">
          {this.state.messageShow &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>Message:</strong>{" "}
                {this.state.alertMessage}
              </Alert>
            </div>
          )}
          <Row>
              <Col md={6} xs={12}>
                  <Row>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Charity Name:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Charity Name"
                          value={this.state.charity_name}
                          name="charity_name"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.charity_nameError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Email Address:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Email Address"
                          value={this.state.email}
                          name="email"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.emailError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel>Phone:</ControlLabel>
                        <NumberFormat
	                        format="###-###-####"
	                        mask="_"
	                        className="form-control"
	                        name="phone"
	                        placeholder="Enter Phone Number"
	                        value={this.state.phone}
	                        onChange={this.handleChange}
	                        autoComplete="off"
	                        style={{borderColor:this.state.phoneError}}
	                      />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Address 1:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Address 1"
                          value={this.state.address1}
                          name="address1"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.address1Error}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel>Address 2:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Address 2"
                          value={this.state.address2}
                          name="address2"
                          onChange={this.handleChange}
                        />
                        </FormGroup>
                      </Col>
                  </Row>
              </Col>
              <Col md={6} xs={12}>
                  <Row>
                      <Col md={12} xs={126}>
                      	<CountryStateCity 
                          onSelectedCountry={this.onSelectedCountry}
                          onSelectedState={this.onSelectedState}
                          onSelectedCity={this.onSelectedCity}
                          country={this.state.country}
                          countryName={this.state.countryName}
                          state={this.state.state}
                          stateAbbr={this.state.stateAbbr}
                          city={this.state.city}
                          cityID={this.state.cityID}
                          countryerror={this.state.countryerror}
                          stateerror={this.state.stateerror}
                          cityerror={this.state.cityerror}
                        />
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel>Zip Code:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Zip Code"
                          value={this.state.zipcode}
                          name="zipcode"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.zipcodeError}}
                        />
                        </FormGroup>
                      </Col>
                  </Row>
              </Col>
          </Row>
          <Row>
          <hr/>
          </Row>
          <Row>
            <Col md={12} xs={12}>
            	<Button bsStyle="default" className="pull-right" onClick={() => history.push('/charity/list')}>Cancel</Button>
              	<Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.charityReducer.error,
      charityResponse:  state.charityReducer.charityResponse,
      exportStatus:  state.emailManagerReducer.exportStatus,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {addCharity, renderAlert, clearAlert})
)(AddCharity);


// WEBPACK FOOTER //
// ./src/app/views/admin/charity/AddCharity.js